<template>
	<div class="welcome-message-container">
		<h3>Get Started <modal-help link="https://blog.zwiz.ai/zwiz-ai-auto-reply#welcome" v-if="!$store.state.theme.hide_zwiz"></modal-help> <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" @click="showPreview = true"><span class="glyphicon glyphicon-eye-open"></span> Preview</a></h3>
		<hr>
		<div class="row">
			
			<div class="col-sm-12">
				<div>
					<h4>Welcome Message <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" style="margin-right: 5px;" v-if="!isEdit" @click="isEdit = true"><span class="glyphicon glyphicon-pencil"></span> Edit</a></h4>
					<span class="small">เมื่อผู้ใช้กดปุ่ม Get Started หรือ สนทนากับเพจครั้งแรก ระบบจะสามารถส่งข้อความอัตโนมัติ Welcome Message </span>
					<div style="margin-bottom: 0px;margin-top: 15px;">
						<div class="row" v-if="isEdit">
							<div class="col-xs-12 col-sm-12" style="margin-bottom:10px">
								<a href="javascript:void(0);" v-for="(option) in typeOptions" :key="'option_'+option.value" class="btn btn-none-radius" :class="{'btn-default': type != option.value, 'btn-primary': type == option.value}" @click="onOptionChange(option.value)" style="margin-right:5px;margin-bottom:5px;">{{option.name}}</a>
							</div>
						</div>

						<div v-if="type == 'message'">
							<template v-if="isEdit">
								<div :class="{'has-error': errors.has('answer[]')}">
									<intent-group v-model="message"></intent-group>
								</div>
								<div class="clearfix"></div>
							</template>
							<template v-else>
								<message-viewer v-model="message"></message-viewer>
							</template>

							<div class="text-right">
							<!-- <a href="javascript:void(0);" class="btn btn-primary" @click="saveWelcomeMessage()">Save</a> -->
							</div>
						</div>

						<div v-else-if="type == 'generic'">
							<template v-if="isEdit">
								<div style="overflow-x:scroll;margin-bottom:5px;">
									<div style="margin:0;overflow:auto;" :style="{'width': ((generics.length * 315) + (generics.length < 10 ? 315 : 0)) +'px'}">
										<!-- <draggable :list="generics" class="dragArea" :move="checkMove"> -->
											<div style="float:left;width:300px;margin-right: 15px;" v-for="(generic,index) in generics" :key="'generic_'+index">
												<!-- <welcome-message-generic v-model="generics[index]" @onSave="saveWelcomeMessage()">
													<move-horizontal slot="move" :index="index" :max="generics.length" @onMove="onMove(index,$event)"></move-horizontal>
												</welcome-message-generic> -->

												<generic-manage :vkey="index" v-model="generics[index]" @onDelete="onDeleteGeneric(index)">
													<move-horizontal slot="move" :index="index" :max="generics.length" @onMove="onMove(index,$event)"></move-horizontal>
												</generic-manage>

											</div>
											<div v-if="generics.length < 10" @click="addGeneric" style="position:relative;float:left;width:300px;border: 4px dashed #eee;border-radius: 20px;height: 300px;cursor:pointer">
												<div style="position:absolute;left: 50%;top: 50%;margin-left: -10px;margin-top: -23px;font-size: 32px;">
													<span class="glyphicon glyphicon-plus"></span>
												</div>
											</div>
										<!-- </draggable> -->
										

									</div>
									<div class="clearfix"></div>
								</div>
							</template>
							<template v-else>
								<generic-viewer v-model="generics"></generic-viewer>
							</template>
						</div>
					</div>

					<div class="text-center" style="margin-top: 25px;margin-bottom: 25px;">
						<template v-if="isEdit">
							<div class="has-error">
								<p class="text-error" v-show="errors.has('answer[]')">{{ errors.first('answer[]') }}</p>
							</div>
							<a href="javascript:void(0);" class="btn btn-default" @click="cancelEdit">Cancel</a>
							<a href="javascript:void(0);" class="btn btn-primary" @click="saveContent">Save</a>
						</template>
						
					</div>
				</div>

				<hr>

				<quick-reply v-model="welcome_quickreplies"></quick-reply>

				<hr>

				<persistent-menu v-model="persistent_menu"></persistent-menu>
			</div>

			
		</div>

		<modal-dialog v-if="showPreview" @close="showPreview = false">
			<div slot="header">Preview</div>

			<div slot="body">
				<div  style="border: 1px solid #eee;padding: 20px 0px;background: #6b6b6b">
					<!-- <h3 style="text-align: center; color:white">Preview</h3> -->
					<facebook-screen :pagename="selectedBot.pagename" style="overflow-x: auto;padding: 15px">
						<div slot="body" style="position: relative;">
							<div>
								
								<div class="message" style="margin-bottom: 10px;float:right;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;">
									<div style="font-size: 12px;color:white">
										<div style="padding: 5px 8px 6px;background-color:#3578e5">
											<span style="line-height:15.36px;">Get Started</span>
										</div>
									</div>
								</div>

								<div class="clearfix"></div>

							</div>

							<div style="min-height: 200px">
								<img :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=300&height=300'" alt="" style="width: 28px; height: 28px;border: 1px solid #eee;border-radius: 50%; float: left;margin-right: 5px;">
								<template v-if="type == 'message'">
									<!-- <div class="message" style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;">
										<div style="font-size: 12px;color:black">
											<div style="padding: 5px 8px 6px;background-color:#F1F0F0">
												<span style="line-height:15.36px;"><template v-if="message != '' && message != null"><specialtext :text="message"></specialtext></template><template v-else>Message</template></span>
											</div>
										</div>
									</div> -->
									<message-viewer v-model="message" style="overflow: auto"></message-viewer>
								</template>
								<template v-else-if="type == 'generic'">
									<generic-viewer v-model="generics"></generic-viewer>
								</template>

							</div>
							
						</div>
						<div slot="quick_reply" style="position:relative" v-if="welcome_quickreplies && welcome_quickreplies.contentvalue != ''">
							<div style="padding-bottom: 30px"></div>
							<div style="padding-top: 10px;margin: auto;width: 100%;text-align:center;position: absolute; bottom: 0;overflow-x: auto; overflow-y: hidden;height: 40px;white-space: nowrap;">
								<ul style="margin: auto;padding: 0">
									<li v-for="(reply, index) in replies" :key="'reply_'+index" style="list-style-type: none;display:inline;padding: 5px 10px;border: 1px solid #0284ff;margin-right: 5px;border-radius: 20px;color:#0284ff;">
										{{reply.text}}
									</li>
								</ul>

							</div>
						</div>
						<div slot="footer" style="border-top: 1px solid #eee">
							<img src="/static/img/assets/facebook_ui/iOS Composer Default.png" class="img-responsive" alt="">
						</div>
					</facebook-screen>

				</div>
			</div>

			<div slot="footer">
				<a href="javascript:void(0);" class="btn btn-primary" @click="showPreview = false">Close</a>
			</div>
		</modal-dialog>
		
	</div>
</template>

<script>
import { Picker } from 'emoji-mart-vue'
import { mapGetters } from 'vuex'
import uploadfile from '@/components/elements/uploadfile'
import { Carousel, Slide } from 'vue-carousel';
import axios from 'axios'
import config from '@/config'
import api from '@/api'

import WelcomeMessageGeneric from './WelcomeMessageGeneric'
import FacebookScreen from '@/components/elements/FacebookScreen'
import specialtext from '@/components/elements/specialtext'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import Draggable from 'vuedraggable'

import VueTagsInput from '@johmun/vue-tags-input';
import QuickReply from '@/components/view/chatbot/QuickReply'
import PersistentMenu from './PersistentMenu'

import ModalDialog from '@/components/elements/ModalDialog'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import IntentGroup from '@/components/view/intent/IntentGroup'

import GenericManage from '@/components/elements/GenericManage'
import ModalHelp from '@/components/elements/ModalHelp'

export default {
	props: ['init'],
	components: {
		// WelcomeMessageGeneric,
		FacebookScreen,
		specialtext,
		GenericViewer,
		MessageViewer,
		Picker,
		Draggable,
		QuickReply,
		ModalDialog,
		PersistentMenu,
		MoveHorizontal,
		IntentGroup,
		GenericManage,
		ModalHelp
	},
	data : function (){
		return {
			isEdit: false,
			showPreview: false,
			message: null,
			generics: [
				{
					image_url: null,
					title: '',
					subtitle: '',
					buttons: [],

					enable: true
				},
			],
			type: 'message',

			typeOptions: [
				{
					'value' : 'message',
					'name' : 'Text'
				},
				{
					'value' : 'generic',
					'name' : 'Generic' 
				}
			],

			showEmoji: false,
			
			contents: {},

			welcome_quickreplies: undefined,
			persistent_menu: undefined
		}
	},
	computed: {
		...mapGetters({
			selectedBot: 'selectedBot'
		}),
		pageid: function(){
			if (!this.$store.state.selectedBot) {
				return null
			}
			return this.$store.state.selectedBot.pageid
		},
		replies: function(){
			var vm  =this
			if (vm.welcome_quickreplies && vm.welcome_quickreplies.contentvalue && vm.welcome_quickreplies.contentvalue != null && vm.welcome_quickreplies.contentvalue != '') {
                        
				var tags = vm.welcome_quickreplies.contentvalue.split(",")
				var result = []
				$.each(tags,function(index,val){
					result.push({ text : val })
				})
				return result;
			} else {
				return []
			}
		}
	},
	created: function(){
		var vm = this

		vm.getSetting(function(){
			if (vm.contents.welcome_quickreplies) {
				vm.welcome_quickreplies = vm.contents.welcome_quickreplies
			}
		})
		vm.getWelcomeMessage(function(){

			vm.cached_message = vm.message
			vm.cached_generics = []
			$.each(vm.generics,function(index, generic){
				vm.cached_generics[index] = Object.assign({}, generic);
				vm.cached_generics[index].buttons = []
				$.each(generic.buttons,function(bindex,button){
					vm.cached_generics[index].buttons[bindex] = Object.assign({}, button);
				})
			})
			vm.cached_type = vm.type
		});

		vm.getPersistentMenu(function(){

		})
	},
	methods: {
		onOptionChange: function(option){
			this.type = option
			// this.saveWelcomeMessage()
		},
		getWelcomeMessage: function(callback){
			let vm = this
			vm.$store.dispatch('loading')
			let data = {
				'pageid' : vm.selectedBot.pageid
			};

			vm.message = null
			vm.generics = [
				{
					image_url: null,
					title: '',
					subtitle: '',
					buttons: [],

					enable: true
				},

			]
			vm.type = 'message'
			api.getWelcomeMessage(data,function(error, response){
				if (error) {
					console.error(error)
					vm.$store.dispatch('loading')
					return
				}
				if (response.data) {
					vm.type = response.data.type
					vm.message = response.data.message_text ? response.data.message_text : ''
					if (response.data.message && typeof response.data.message === 'object' && response.data.message.length > 0) {
						$.each(response.data.message,function(index,val){
							vm.generics[index] = val
							vm.generics[index].enable = true
						})
					}

				}
				callback()
				vm.$store.dispatch('loading')
			})
		},
		getPersistentMenu: function(callback){
			var vm = this
			var url = 'https://graph.facebook.com/me/messenger_profile?fields=persistent_menu&access_token=' + vm.$store.state.selectedBot.page_access_token
			axios.get(url).then(response => {
				if (response.status == 200) {
					var response = response.data
					if (response.data[0] && response.data[0]['persistent_menu'] && response.data[0]['persistent_menu'][0] && response.data[0]['persistent_menu'][0]['call_to_actions']) {
						vm.persistent_menu = response.data[0]['persistent_menu'][0]['call_to_actions']                            
						callback()
					}
				}
				
			})
		},
		addGeneric: function(){
			if (this.generics.length < 10) {
				
				this.generics.push(
				{
					image_url: null,
					title: '',
					subtitle: '',
					buttons: [],
	
					enable: true
				})
			}
		},
		onDeleteGeneric: function(index){
			if (this.generics.length > 1 ) {
				
				this.generics.splice(index,1)
			} else {
				alert("Welcome Message cannot be less than 1")
			}
		},
		saveWelcomeMessage: function(){
			let vm = this
			let data = {
				'pageid' : vm.$store.state.selectedBot.pageid,
				'type' : vm.type
			};

			

				vm.$store.dispatch('loading')
				if (vm.type == 'message') {
					data['message'] = vm.message
				} else {
					$.each(vm.generics,function(index, generic){
						$.each(generic.buttons,function(gindex, button){
							if (button.type == 'web_url') {
								delete vm.generics[index].buttons[gindex].payload
							} else if(button.type == 'postback'){
								delete vm.generics[index].buttons[gindex].url
							}
						})
					})
					data['message'] = vm.generics
				}

				api.saveWelcomeMessage(data,function(error, response){
					if (error) {
						console.error(error)
						vm.$store.dispatch('loading')
						return
					}
					// console.log(data)
					vm.cached_type = vm.type
					vm.$store.dispatch('loading')
				})

		},
		cancelEdit: function(){
			var vm = this
			this.message = this.cached_message
			vm.generics = []
			$.each(vm.cached_generics,function(index, generic){
				vm.generics[index] = Object.assign({}, generic);
				vm.generics[index].buttons = []
				$.each(generic.buttons,function(bindex,button){
					vm.generics[index].buttons[bindex] = Object.assign({}, button);
				})
			})
			vm.type = vm.cached_type
			vm.isEdit = false
		},
		saveContent: function(){
			var vm = this
			vm.$validator.validateAll().then(result => {
				if (!result) {
					vm.goToErrorInput()
					// do stuff if not valid.
						// console.log(this.$validator.errors.items)
						return false
					}
			vm.saveWelcomeMessage()
			if (vm.type == 'message') {				
				vm.cached_message = vm.message		
			} else {
				vm.cached_generics = []
				$.each(vm.generics,function(index, generic){
					vm.cached_generics[index] = Object.assign({}, generic);
					vm.cached_generics[index].buttons = []
					$.each(generic.buttons,function(bindex,button){
						vm.cached_generics[index].buttons[bindex] = Object.assign({}, button);
					})
				})
			}
			vm.isEdit = false

			})
		},
		addEmoji: function(emoji){
			this.message += emoji.native
			this.showEmoji = false
		},
		checkMove: function(event){

		},
		getSetting: function(callback){
			let vm = this
			if (!vm.pageid || vm.pageid == null) {
				return false;
			}
			var data = {
				pageid:  vm.$store.state.selectedBot.pageid
			}

			api.getSetting(data,function(error, response){
				if (error) {
					console.error(error)
					return
				}
				
				vm.contents = {}
				$.each(response.data,function(index, val){
					vm.contents[val.contenttype] = val
					if (val.contenttype == 'allowtransfer') {
						vm.isTransfer = val.contentvalue
					}
				})
				callback()

			})
			
		},
		onMove: function(index, direction){
			var vm = this
			if (direction == 'left') {
				vm.generics.splice(index, 0, vm.generics.splice(index-1, 1)[0]);
			} else if(direction == 'right') {
				vm.generics.splice(index, 0, vm.generics.splice(index+1, 1)[0]);
			}
		}
	},
	watch: {
		selectedBot: function( newVal , oldVal){
			this.getWelcomeMessage(function(){
				
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/setting/WelcomeMessage.vue